import { inject } from '@angular/core';
import type { CanMatchFn } from '@angular/router';
import { Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

/** Blocks route access when the user lacks the required permission code. */
export function permissionGuard(code: string): CanMatchFn {
  return async () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    await auth.waitUntilInitialized();

    if (!auth.isAuthenticated()) {
      return router.createUrlTree(['/login']);
    }

    if (code === '__super_admin__') {
      return auth.roles().includes('super_admin') || router.createUrlTree(['/403']);
    }

    if (auth.hasPermission(code)) {
      return true;
    }

    return router.createUrlTree(['/403']);
  };
}
